import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=1a97f95e&"
import script from "./Newsletter.vue?vue&type=script&lang=ts&"
export * from "./Newsletter.vue?vue&type=script&lang=ts&"
import style0 from "./Newsletter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VFlex,VLayout})
